import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { tollOperations } from '../store';

type TollOperations = typeof tollOperations;

export const useTollOperations = (): TollOperations => {
  const bindedActions = useBindActionCreators<TollOperations>(tollOperations);
  return bindedActions;
};
